"use client";

import Image from "next/image";
import React from "react";
import { useTranslation } from "react-i18next";

import linkedinLogo from "@/public/assets/Linkedin-logo.png";
import upworkLogo from "@/public/assets/Upwork-logo.png";
import glassdoorLogo from "@/public/assets/Glassdoor-Logo.png";
import fiverrLogo from "@/public/assets/fiverr-logo.png";
import indeedLogo from "@/public/assets/Indeed-Logo.png";

const logoSizes = "(min-width: 1024px) 160px, 112px";

const LogoTicker = () => {
	const { t } = useTranslation();

	return (
		<div className='py-4 md:py-6 lg:py-10'>
			<div className='container'>
				<p className='mb-4 text-center text-sm font-semibold uppercase tracking-[0.16em] text-slate-600 dark:text-slate-300 lg:mb-6 lg:text-lg lg:tracking-[0.2em]'>
					{t("HOME_LOGOTICKER_TEXT")}
				</p>
				<div className='flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black,transparent)]'>
					<div className='flex flex-none gap-10 lg:gap-14 animate-logo-ticker'>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={linkedinLogo}
							sizes={logoSizes}
							alt='Linkedin Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={upworkLogo}
							sizes={logoSizes}
							alt='Upwork Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={glassdoorLogo}
							sizes={logoSizes}
							alt='Glassdoor Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={fiverrLogo}
							sizes={logoSizes}
							alt='Fiverr Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={indeedLogo}
							sizes={logoSizes}
							alt='Indeed Logo'
						/>

						{/* Second set of logos for animation */}
            <Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={linkedinLogo}
							sizes={logoSizes}
							alt='Linkedin Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={upworkLogo}
							sizes={logoSizes}
							alt='Upwork Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={glassdoorLogo}
							sizes={logoSizes}
							alt='Glassdoor Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={fiverrLogo}
							sizes={logoSizes}
							alt='Fiverr Logo'
						/>
						<Image
                    className='logo-ticker-image dark:mix-blend-multiply dark:opacity-90'
							src={indeedLogo}
							sizes={logoSizes}
							alt='Indeed Logo'
						/>

					</div>
				</div>
			</div>
		</div>
	);
};

export default LogoTicker;
